import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPreviewFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPreviewFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ab4304eb4c057d5438d99bbcce49535100674fd2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '684e362ea484c9bfc74bcaf3b8ef44448832a00e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ca873adca94dafec0da45cd2bfb445fb7c68d7f5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.82 11.29a.55.55 0 0 0 0-.58C16.86 7.83 14.32 6 11 6s-5.85 1.83-7.8 4.71a.53.53 0 0 0 0 .58C5.12 14.19 7.69 16 11 16s5.9-1.81 7.82-4.71M11 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-preview-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-preview-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-preview-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPreviewFilled$1);
            }
            break;
    } });
}

const CosmosIconPreviewFilled = CosmosIconPreviewFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPreviewFilled, defineCustomElement };
